import React from 'react';
import { IDeletePlannedActivityDialog } from './interfaces';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';
import { ROUTES } from '../../../../routes/Routes';
import { useNavigate } from 'react-router';
import { useDeletePlannedActivity } from '../../../../reactQuery/Activities/activities';

export const DeletePlannedActivityDialog: React.FC<
  IDeletePlannedActivityDialog
> = ({ show, plannedActivityId, onClose }): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    mutate: deletePlannedActivity,
    isLoading: isDeletingPlannedActivity,
  } = useDeletePlannedActivity();

  const onDeletePlannedActivity = (): void => {
    deletePlannedActivity(plannedActivityId, {
      onSuccess: () => {
        enqueueSnackbar(
          t('plannedActivities:prompts.deletePlannedActivity.success'),
          {
            variant: 'success',
          }
        );
        navigate(ROUTES.activities.overview);
      },
      onError: () => {
        enqueueSnackbar(
          t('plannedActivities:prompts.deletePlannedActivity.failed'),
          {
            variant: 'error',
          }
        );
      },
    });
  };

  return (
    <Dialog open={show}>
      <DialogTitle fontWeight="bold">
        {t('plannedActivities:prompts.deletePlannedActivity.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Trans
            i18nKey="plannedActivities:prompts.deletePlannedActivity.body"
            components={{ strong: <strong /> }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
          disabled={isDeletingPlannedActivity}
        >
          {t('buttons.cancel')}
        </Button>
        <Button
          onClick={onDeletePlannedActivity}
          color="error"
          variant="contained"
          disabled={isDeletingPlannedActivity}
        >
          {t('buttons.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
